import { render, staticRenderFns } from "./CmgTwoStepVerificationWelcomeModal.vue?vue&type=template&id=134f9240&scoped=true&lang=pug&"
import script from "./cmg-two-step-verification-welcome-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-two-step-verification-welcome-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgTwoStepVerificationWelcomeModal.vue?vue&type=style&index=0&id=134f9240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f9240",
  null
  
)

export default component.exports